var map = {
	"./Animales/Bitacora": 4395,
	"./Animales/Bitacora.vue": 4395,
	"./Animales/Create": 8125,
	"./Animales/Create.vue": 8125,
	"./Animales/Dashboard": 8134,
	"./Animales/Dashboard.vue": 8134,
	"./Animales/Edit": 6532,
	"./Animales/Edit.vue": 6532,
	"./Animales/Index": 2751,
	"./Animales/Index.vue": 2751,
	"./Auth/Login": 5500,
	"./Auth/Login.vue": 5500,
	"./Especies/Edit": 4909,
	"./Especies/Edit.vue": 4909,
	"./Especies/Index": 1165,
	"./Especies/Index.vue": 1165,
	"./EventosReproductivos/Index": 4603,
	"./EventosReproductivos/Index.vue": 4603,
	"./Gestaciones/Index": 3294,
	"./Gestaciones/Index.vue": 3294,
	"./Organizations/Create": 5343,
	"./Organizations/Create.vue": 5343,
	"./Organizations/Edit": 3514,
	"./Organizations/Edit.vue": 3514,
	"./Organizations/Index": 1799,
	"./Organizations/Index.vue": 1799,
	"./Pesos/Index": 5041,
	"./Pesos/Index.vue": 5041,
	"./Proyectos/Create": 2042,
	"./Proyectos/Create.vue": 2042,
	"./Proyectos/Edit": 3080,
	"./Proyectos/Edit.vue": 3080,
	"./Proyectos/Index": 1757,
	"./Proyectos/Index.vue": 1757,
	"./Razas/Edit": 2257,
	"./Razas/Edit.vue": 2257,
	"./Razas/Index": 9181,
	"./Razas/Index.vue": 9181,
	"./Reports/Index": 8791,
	"./Reports/Index.vue": 8791,
	"./Tecnicos/Edit": 8946,
	"./Tecnicos/Edit.vue": 8946,
	"./Tecnicos/Index": 2324,
	"./Tecnicos/Index.vue": 2324,
	"./Users/Create": 2498,
	"./Users/Create.vue": 2498,
	"./Users/Edit": 32,
	"./Users/Edit.vue": 32,
	"./Users/Index": 9682,
	"./Users/Index.vue": 9682,
	"./Vacunas/Index": 3248,
	"./Vacunas/Index.vue": 3248,
	"./Ventas/Edit": 8049,
	"./Ventas/Edit.vue": 8049
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;